<div class="row m-3">
  @for (history of rapportHistories; track history.id) {
    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Version :</span>
      <p>{{ history.versionNumber }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Date de création :</span>
      <p>{{ history.creationDate | date:'short' }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Rapport :</span>
      <p>{{ history.interpretations }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <button (click)="downloadPdf(history)">Télécharger PDF</button>
    </div>



    <hr class="mt-3" *ngIf="!$last" />
  } @empty {
    <div style="height: 200px" class="text-center text-muted mt-4">
      Aucun historique de rapport disponible.
    </div>
  }
</div>
